module.exports = __webpack_public_path__ + "media/app/components/Footer/GoogleStoreVi.d4880bcb.svg";